import React from "react";
import { Navigate } from "react-router-dom";

const WissensTest = () => <Navigate to="/assessment/wt" replace />;

export default WissensTest;
